// extracted by mini-css-extract-plugin
export default {"text":"NetworkName_text__WrbsR","warning":"NetworkName_warning__RR6Ie"};